import { parseColor } from '../_colorUtils';

export const ACtaTextMixin = (superClass) => class extends superClass {
    static get observedAttributes() {
        return ['data-color'];
    }

    constructor() {
        super();
        this.refs = {
            content: document.createElement('span')
        };
        this.refs.content.className = 'btn-content';
        while (this.childNodes.length > 0) {
            this.refs.content.appendChild(this.childNodes[0]);
        }
        this.appendChild(this.refs.content);

        this.setColor();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'data-color':
                this.setColor(newValue);
                break;

            default:
                break;
        }
    }

    setColor(value) {
        const colorVarName = '--theme-cta-color';
        this.style.removeProperty(colorVarName);
        if (value !== undefined) {
            try {
                const color = parseColor(value);
                this.style.setProperty(colorVarName, `${color.r} ${color.g} ${color.b}`);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
    }
};
